module.exports = __webpack_public_path__ + "static/media/ScienceCATIcon.8c830b12.svg";